import { render, staticRenderFns } from "./DirectImageUploader.vue?vue&type=template&id=130174c2&scoped=true&"
import script from "./DirectImageUploader.vue?vue&type=script&lang=js&"
export * from "./DirectImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./DirectImageUploader.vue?vue&type=style&index=0&id=130174c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130174c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VOverlay,VProgressCircular,VProgressLinear,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})
